import { render, staticRenderFns } from "./KnowledgeBaseUserIcon.vue?vue&type=template&id=511ea586&scoped=true"
import script from "./KnowledgeBaseUserIcon.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseUserIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511ea586",
  null
  
)

export default component.exports